import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeRoutingModule } from './home-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import {  HomePageComponent } from 'src/app/pages/home/home-page/home-page.component';
import { SharedComponentsModule } from '../../shared-components/shared-components.module';
import { MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule  } from '@angular/material/datepicker';
import { MatNativeDateModule} from '@angular/material/core';
import { ToastrModule} from 'ngx-toastr';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NgApexchartsModule } from 'ng-apexcharts';


@NgModule({
  declarations:
    [
      HomePageComponent,
      DashboardComponent
    ],
  imports: [
    CommonModule,
    TranslateModule,
    HomeRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedComponentsModule,
    MatStepperModule,
    MatIconModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule, 
    MatDialogModule,
    MatAutocompleteModule,
    NgApexchartsModule,
    ToastrModule.forRoot({
      timeOut: 400000,
      positionClass: 'toast-bottom-right'
    }) 
  ],
  entryComponents: [
    
  ],
  providers: [
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
 
})
export class HomeModule {}
